import { type ReorderEvent, type ReorderEventParams } from '../types';

// ─────────────────────────────────────────────────────────────────────────────

export function getReorderEventParams(args: { event: ReorderEvent }): ReorderEventParams {
  return { reorderEvent: args.event };
}
